// src/utils/export/recollection/exportCSV.js

export function exportArrayToCSV({ headers = [], rows = [], filename = "data.csv" }) {
  const csvContent = [headers, ...rows]
    .map(row =>
      row.map(field => `"${String(field ?? "").replace(/"/g, '""')}"`).join(",")
    )
    .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
